<template>
  <sp-chip v-if="hasBadge" variant="plain" class="sp-finder-result-badges" part="base">
    <sp-img
      v-if="iconUrl"
      slot="prepend"
      class="sp-finder-result-badges__icon"
      :src="iconUrl"
      :alt="t('results.employment_badge_icon')"
    ></sp-img>
    {{ label }}
  </sp-chip>
</template>

<script setup>
import { computed } from "vue";
import { i18n } from "#ce/components/SpFinder/i18n";

function t(...args) {
  return i18n.global.t(...args);
}

const props = defineProps({
  /**
   * The employer badge: `text` and an optional `icon_url`.
   *
   * @type {Object}
   */
  badge: {
    type: Object,
    default: null,
  },
  /**
   * Shown when the provider has no employer badge.
   *
   * @type {String}
   */
  independentBadgeText: {
    type: String,
    default: "",
  },
});

const label = computed(() => props.badge?.text || props.independentBadgeText);
const iconUrl = computed(() => props.badge?.icon_url);
const hasBadge = computed(() => Boolean(label.value || iconUrl.value));
</script>

<style>
:host {
  display: block;
}
</style>

<style lang="scss" scoped>
.sp-finder-result-badges {
  --badge-icon-size: var(--sp-comp-finder-result-badge-icon-size, var(--sp-ref-scale-18));

  --sp-comp-chip-padding-block: var(--sp-comp-finder-result-badge-padding-block, 0);
  --sp-comp-chip-border-width: var(--sp-comp-finder-result-badge-border-width, 0);
  --sp-comp-chip-gap: var(--sp-comp-finder-result-badge-gap, var(--sp-ref-scale-6));
  --sp-comp-chip-fill-color: var(--sp-comp-finder-result-badge-color, var(--sp-sys-color-on-surface));
  --sp-comp-chip-font-size: var(--sp-comp-finder-result-badge-font-size, var(--sp-ref-scale-12));
  --sp-comp-chip-font-weight: var(--sp-comp-finder-result-badge-font-weight, var(--sp-sys-typescale-body-font-weight));
  --sp-comp-chip-line-height: var(--sp-comp-finder-result-badge-line-height, var(--badge-icon-size));
  --sp-comp-chip-label-white-space: var(--sp-comp-finder-result-badge-white-space, normal);

  margin-block: var(--sp-comp-finder-result-badge-margin-block-start, 5px)
    var(--sp-comp-finder-result-badge-margin-block-end, 5px);

  &__icon {
    --sp-comp-img-height: var(--badge-icon-size);
    --sp-comp-img-width: auto;

    height: var(--badge-icon-size);
  }
}
</style>
